<script lang="ts">
	import {
		DashboardIcon,
		RevenueIcon,
		StoreIcon,
		ProductIcon,
		PointIcon,
		PlaceIcon,
		ManageIcon,
		LoggingIcon,
	} from "@hitit/new_ui";

	// type IconType =
	// 	| "Dashboard"
	// 	| "Revenue"
	// 	| "Store"
	// 	| "Product"
	// 	| "Point"
	// 	| "Place"
	// 	| "Manage"
	// 	| "Logging";

	export let active = false;
	export let hover = false;
	export let iconType: string;

</script>

{#if iconType === 'Dashboard'}
	<div id="dashboard">
		<DashboardIcon active={active} hover={hover} />
	</div>
{:else if iconType === 'Revenue'}
	<div id="revenue">
		<RevenueIcon active={active} hover={hover} />
	</div>
{:else if iconType === 'Store'}
	<div id="store">
		<StoreIcon active={active} hover={hover} />
	</div>
{:else if iconType === 'Product'}
	<div id="product">
		<ProductIcon active={active} hover={hover} />
	</div>
{:else if iconType === 'Point'}
	<div id="point">
		<PointIcon active={active} />
	</div>
{:else if iconType === 'Place'}
	<div id="place">
		<PlaceIcon active={active} hover={hover} />
	</div>
{:else if iconType === 'Manage'}
	<div id="manage">
		<ManageIcon active={active} hover={hover} />
	</div>
{:else if iconType === 'Logging'}
	<div id="logging">
		<LoggingIcon active={active} hover={hover} />
	</div>
{/if}

<style lang="scss">
	@import "../variables.scss";
	div {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	#dashboard {
		width: 20.5px;
		height: 20.5px;
	}

	#revenue {
		width: 20px;
		height: 20px;
	}

	#store {
		width: 20px;
		height: 21.8px;
	}

	#product {
		width: 20px;
		height: 20px;
	}

	#point {
		width: 13.5px;
		height: 20.2px;
	}

	#place {
		width: 20px;
		height: 24.5px;
	}

	#manage {
		width: 20px;
		height: 20px;
	}
	#logging {
		width: 20px;
		height: 19.2px;
	}

	@include DesktopSize {
		#dashboard {
			width: 24.5px;
			height: 24.5px;
		}

		#revenue {
			width: 26px;
			height: 26px;
		}

		#store {
			width: 24.2px;
			height: 26px;
		}

		#product {
			width: 26.2px;
			height: 26.2px;
		}

		#point {
			width: 17.5px;
			height: 26px;
		}

		#place {
			width: 21.2px;
			height: 26px;
		}
		#manage {
			width: 26px;
			height: 26px;
		}
		#logging {
			width: 27.2px;
			height: 26px;
		}
	}

</style>
